import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {distributorT} from '@/lib/types/distributor.types';

interface DISTRIBUTOR_STATE {
  distributors: distributorT[];
  isLoading?: boolean;
  error?: string;
}

const DISTRIBUTOR_INITIAL: DISTRIBUTOR_STATE = {
  distributors: [],
  isLoading: false,
  error: '',
};

const distributorSlice = createSlice({
  name: 'distributor',
  initialState: DISTRIBUTOR_INITIAL,
  reducers: {
    DISTRIBUTOR_UPDATE: (
      state,
      action: PayloadAction<{
        data?: Partial<DISTRIBUTOR_STATE>;
        prop?: keyof DISTRIBUTOR_STATE;
        value?: any;
      }>
    ) => {
      if (action.payload.data) {
        Object.entries(action.payload.data).forEach(([key, value]) => {
          if (key in state) {
            (state as any)[key] = value;
          }
        });
        return state;
      }

      if (action.payload.prop && action.payload.value !== undefined) {
        const prop = action.payload.prop;

        // Narrow the assignment to only properties that exist on the state
        if (prop in state) {
          (state as any)[prop] = action.payload.value;
        }
      }

      return state;
    },
  },
});

const {DISTRIBUTOR_UPDATE} = distributorSlice.actions;

export {distributorSlice, DISTRIBUTOR_INITIAL, DISTRIBUTOR_UPDATE};
